import React, { ReactNode, createContext, Dispatch, SetStateAction } from "react";
import useAuth, { FormPassword, Empresa, UserProps, UserToken } from "./hooks/useAuth";

interface AuthContextProviderProps {
  children: ReactNode;
}

type UserTypeCheck = 1 | 2 | 3 | 4;

const initialState: AuthContextData = {
  user: { password: "", email: "" },
  setUser: () => {},
  authenticated: false,
  empresaRegister: async () => {},
  handleLogin: () => {},
  handleLogout: () => {},
  loadingButton: false,
  objUserTk: { unique_name: "", Type: "Aluno", EmpresaId: 0, UserId: 0, IsManager: false },
  selectTypeUser: 1,
  setSelectTypeUser: () => {},
  formPassword: { password: "", confirmPassword: "" },
  setFormPassword: () => {},
  updateUserPassword: async () => {},
  sendResetPasswordEmail: async () => {},
  verifyResetCode: async () => false,
};

export interface AuthContextData {
  user: { password: string; email: string };
  setUser: (user: UserProps) => void;
  authenticated: boolean;
  empresaRegister: (empresaCreateRequest: Empresa) => void;
  handleLogin: (user: UserProps) => void;
  handleLogout: () => void;
  loadingButton: boolean;
  objUserTk: UserToken;
  selectTypeUser: UserTypeCheck;
  setSelectTypeUser: Dispatch<SetStateAction<UserTypeCheck>>;
  formPassword: FormPassword;
  setFormPassword: (data: FormPassword) => void;
  updateUserPassword: (userId: number, newPassword: string) => Promise<void>;
  sendResetPasswordEmail: (email: string) => Promise<void>;
  verifyResetCode: (email: string, code: string) => Promise<boolean>;
}

export const AuthContext = createContext<AuthContextData>(initialState);

export default function AuthContextProvider({ children }: AuthContextProviderProps) {
  const {
    data,
    authenticated,
    loadingButton,
    empresaRegister,
    handleLogin,
    handleLogout,
    handleSetUser,
    objUserTk,
    selectTypeUser,
    setSelectTypeUser,
    formPassword,
    setFormPassword,
    updateUserPassword,
    sendResetPasswordEmail,
    verifyResetCode,
  } = useAuth();

  return (
    <AuthContext.Provider
      value={{
        user: data,
        setUser: handleSetUser,
        authenticated,
        empresaRegister,
        handleLogin,
        handleLogout,
        loadingButton,
        objUserTk: objUserTk,
        selectTypeUser,
        setSelectTypeUser,
        formPassword,
        setFormPassword,
        updateUserPassword,
        sendResetPasswordEmail,
        verifyResetCode,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
